import * as React from 'react';
import { DrinkEditorRow } from '../DrinkEditorRow';
import { VenueTax } from '../../types';
import { TaxRow } from './TaxRow';
import { Button } from 'react-bootstrap';

type TaxEditorProps = {
  venueTaxes: VenueTax[];
  itemTaxes: VenueTax[];
  onRemoveItemTax(tax: VenueTax);
  onAddTax(tax: VenueTax);
};

export const TaxEditor: React.FC<TaxEditorProps> = ({ itemTaxes, venueTaxes, onAddTax, onRemoveItemTax }) => {
  const [isAdding, setIsAdding] = React.useState(false);
  const availableTaxesToAdd = React.useMemo(() => {
    const itemTaxIds = new Set(itemTaxes?.map((t) => t.id));
    return venueTaxes?.filter((v) => !itemTaxIds.has(v.id));
  }, [venueTaxes, itemTaxes]);

  const onToggleExisting = (tax: VenueTax, isChecked: boolean) => {
    if (!isChecked) {
      onRemoveItemTax(tax);
    }
  };

  const onToggleNew = (tax: VenueTax, isChecked: boolean) => {
    if (isChecked) {
      onAddTax(tax);
    }
  };

  return (
    <DrinkEditorRow label='Taxes'>
      {itemTaxes?.map((tax) => (
        <TaxRow tax={tax} key={tax.id} onCheck={onToggleExisting} isChecked={true} isEditing={true}></TaxRow>
      ))}
      {!isAdding && (
        <Button variant='link' onClick={() => setIsAdding(true)}>
          Add
        </Button>
      )}
      {isAdding &&
        !!availableTaxesToAdd &&
        availableTaxesToAdd.map((tax) => (
          <TaxRow tax={tax} key={tax.id} onCheck={onToggleNew} isChecked={false} isEditing={true}></TaxRow>
        ))}
    </DrinkEditorRow>
  );
};
